import React, { type FunctionComponent } from 'react'
import { DashSwitch } from 'legacy/dash-components/dash-switch/DashSwitch'
import { DashRoute } from 'legacy/dash-components/dash-route/DashRoute'
import { DashRedirect } from 'legacy/dash-components/dash-redirect/DashRedirect'
import { AccountManagementListAccountsPage } from 'domains/account-management/components/pages/admin/AccountManagementListAccountPage'
import { AccountManagementCreateAccountPage } from 'domains/account-management/components/pages/admin/AccountManagementCreateAccountPage'
import { AccountManagementUpdateAccountPage } from 'domains/account-management/components/pages/admin/AccountManagementUpdateAccountPage'

export const AccountManagementAdminSection: FunctionComponent = () => (
  <DashSwitch>
    <DashRoute
      exact
      route="app-admin-account-management-list"
      component={AccountManagementListAccountsPage}
    />

    <DashRoute
      exact
      route="app-admin-account-management-create"
      component={AccountManagementCreateAccountPage}
    />

    <DashRoute
      route="app-admin-account-management-edit"
      component={AccountManagementUpdateAccountPage}
    />

    <DashRedirect toRoute="app-admin-account-management-list" />
  </DashSwitch>
)
